//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//
import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/ManageClients.module.css";
import bootstrap from "../../assets/bootstrapStyles/bootstrap.min.module.css";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { BASE_URL } from "../../components/baseURL";
import $ from "jquery";
import Request from "axios";
import style from "../../assets/styles/weightTrackerGrid.module.css";
//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//

function BloodTracker() {
  //--------------------------------------------------------------------All Variables---------------------------------------------------------------------------//
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [mask] = useState();
  const navigation = useNavigate();
  const userDetails = useSelector((state) => state?.allData?.user_details);
  let temp = JSON.parse(localStorage?.getItem("user"));
  //--------------------------------------------------------------------All Variables---------------------------------------------------------------------------//
  
  //---------------------------------------------------------UseEffect to get Blood Tracker -----------------------------------------------------------------------//

  useEffect(() => {
    Request.get(
      `${BASE_URL}tracker/getBloodTracker?id=${userDetails?.id ? userDetails?.id : temp?.id}`
    )
      .then((res) => {
        setList(res?.data?.data);
        $(() => {
          $("#myTable").DataTable({
            data: res?.data?.data,
            columns: [
              { data: "Haemoglobin" },
              { data: "Uricacid" },
              { data: "Creatine" },
              { data: "Calcium" },
              { data: "Bloodpressure" },
              { data: "Glucosefasting" },
              { data: "Glucosepostprandial" },
              { data: "HbA1c" },
              { data: "ThyroidT3" },
              { data: "ThyroidT4" },
              { data: "ThyroidT4" },
              { data: "CholesterolHDL" },
              { data: "CholesterolLDL" },
              { data: "CholesterolTriglycerides" },
              { data: "CholesterolVLDL" },
            ],
          });
        });
        setTimeout(() => {
          styleChanges();
        }, [200]);
      })
      .catch((err) => {
        alert("Error fetching clients", err);
        console.log("Error fetching clients", err);
      });
  }, []);

  //---------------------------------------------------------UseEffect to get Blood Tracker -----------------------------------------------------------------------//
  
  //---------------------------------------------------------Style Change Function-----------------------------------------------------------------------//

  function styleChanges() {
    document
      .querySelectorAll(".dataTables_length")
      .forEach((el) => (el.style.marginBottom = "40px"));
    document
      .querySelectorAll(".dataTables_wrapper")
      .forEach((el) => (el.style.overflow = "scroll"));
    document.querySelectorAll(".dataTables_wrapper").forEach((el) => (el.style.position = "unset"));
    document
      .querySelectorAll(".dataTables_filter")
      .forEach((el) => (el.style.marginRight = "20px"));
    document
      .querySelectorAll(".dataTables_filter")
      .forEach((el) => (el.style.marginBottom = "20px"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach(
        (el) =>
          (el.style.background = `url(https://static.thenounproject.com/png/101791-200.png) no-repeat`)
      );
    document.querySelectorAll(".dataTables_length").forEach((el) => (el.style.marginLeft = "20px"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach((el) => (el.style.backgroundSize = "22px"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach((el) => (el.style.backgroundPosition = "386px 15px"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach((el) => (el.style.paddingRight = "25px"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach((el) => (el.style.backgroundColor = "#f5f5f5"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach((el) => (el.style.width = "420px"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach((el) => (el.style.height = "50px"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach((el) => (el.style.border = "unset"));
    document
      .querySelectorAll(".dataTables_filter input")
      .forEach((el) => (el.style.borderRadius = "50px"));
    document
      .querySelectorAll(".dataTables_wrapper .dataTables_info")
      .forEach((el) => (el.style.paddingLeft = "10px"));
    document.querySelectorAll(".paginate_button").forEach((el) => (el.style.color = "#FFFFFF"));
    // document.querySelectorAll(".paginate_button").forEach((el) => (el.style.background = "#00C1BD"));
    // document.querySelectorAll(".paginate_button").forEach((el) => (el.style.border = "1px solid #00C1BD"));
    document.querySelectorAll(".paginate_button").forEach((el) => (el.style.borderRadius = "4px"));
  }

  //---------------------------------------------------------Style Change Function-----------------------------------------------------------------------//
  
  //---------------------------------------------------------UseEffect to style Table -----------------------------------------------------------------------//

  useEffect(() => {
    document
      .querySelectorAll("#myTable")
      .forEach((el) => (el.style.paddingBottom = mask ? "150px" : "50px"));
  }, [mask]);

  //---------------------------------------------------------UseEffect to style Table -----------------------------------------------------------------------//
  
  //---------------------------------------------------------UseEffect to Dispatch Routes -----------------------------------------------------------------------//

  useEffect(() => {
    // setTimeout(() => {
    //   styleChanges();
    // }, [200]);
    dispatch({ type: "ROUTES", payload: "Weight Tracker" });
  }, []);

  //---------------------------------------------------------UseEffect to Dispatch Routes -----------------------------------------------------------------------//

  return (
    <div className={style.weightTrackerMainDiv}>
      <div
        className={style.backButtonDiv}
        onClick={() => {
          temp?.Role === "Admin" ? navigation("/manageclients") : navigation("/clientdashboard");
        }}
      >
        {/* <img src={} alt="" /> */}
        <label> &lt; Back</label>
      </div>
      {/* <div className={style.setwidth}>
        <button className={style.excelbtn}>
          <img src={excelExport} alt="" />
          Excel Export
        </button>
      </div> */}
      <table
        id="myTable"
        className={bootstrap[("table", "table-striped")] + " " + styles.tableCustomcls}
      >
        <thead>
          <tr>
            <th className={styles.Tablefontcls}>Date</th>
            <th className={styles.Tablefontcls}>Hemoglobin </th>
            <th className={styles.Tablefontcls}>Uric Acid </th>
            <th className={styles.Tablefontcls}>Creatine</th>
            <th className={styles.Tablefontcls}>Calcium </th>
            <th className={styles.Tablefontcls}>Blood Pressure</th>
            <th className={styles.Tablefontcls}>Glucose Fasting</th>
            <th className={styles.Tablefontcls}>Glucose Post Prandial </th>
            <th className={styles.Tablefontcls}>HbA1c</th>
            <th className={styles.Tablefontcls}>T3</th>
            <th className={styles.Tablefontcls}>T4</th>
            <th className={styles.Tablefontcls}>T4</th>
            <th className={styles.Tablefontcls}>HDL</th>
            <th className={styles.Tablefontcls}>LDL</th>
            <th className={styles.Tablefontcls}>Triglycerides</th>
            <th className={styles.Tablefontcls}>VLDL</th>
          </tr>
        </thead>
        <tbody>
          {list?.length > 0 ? (
            list?.map((val, i) => {
              return (
                <tr key={String(i)}>
                  <td className={styles.Tablefonttdcls}>
                    {moment(val?.Date).format("YYYY-MM-DD")}
                  </td>
                  <td className={styles.Tablefonttdcls}>{val?.Haemoglobin}</td>
                  <td className={styles.Tablefonttdcls}>{val?.Uricacid}</td>
                  <td className={styles.Tablefonttdcls}>{val?.Creatine}</td>
                  <td className={styles.Tablefonttdcls}>{val?.Calcium}</td>
                  <td className={styles.Tablefonttdcls}>{val?.Bloodpressure}</td>
                  <td className={styles.Tablefonttdcls}>{val?.Glucosefasting}</td>
                  <td className={styles.Tablefonttdcls}>{val?.Glucosepostprandial}</td>
                  <td className={styles.Tablefonttdcls}>{val?.HbA1c}</td>
                  <td className={styles.Tablefonttdcls}>{val?.ThyroidT3}</td>
                  <td className={styles.Tablefonttdcls}>{val?.ThyroidT4}</td>
                  <td className={styles.Tablefonttdcls}>{val?.ThyroidT4}</td>
                  <td className={styles.Tablefonttdcls}>{val?.CholesterolHDL}</td>
                  <td className={styles.Tablefonttdcls}>{val?.CholesterolLDL}</td>
                  <td className={styles.Tablefonttdcls}>{val?.CholesterolTriglycerides}</td>
                  <td className={styles.Tablefonttdcls}>{val?.CholesterolVLDL}</td>
                </tr>
              );
            })
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default BloodTracker;
